import React, { useContext } from "react";
import { Box, Grid } from "@material-ui/core";
import PageStoreContext from "../../context";
import { DateTimePicker } from "@material-ui/pickers";
import { FormControl } from "../../../../../../common/components/libs";
import moment from "moment";
import { observer } from "mobx-react";
import {Period} from "../../../../../../services/stats/models";
import { SnackbarType } from "../../../../../../stores/common";
import { useStores } from "../../../../../../hooks";
import {Trans, useTranslation} from "react-i18next";


interface Props {

}

const CustomTab = () => {
    const pageStore = useContext(PageStoreContext);
    const {generalStore} = useStores()
    const {i18n, t} = useTranslation(["general"]);
    const locale = i18n.language;

    return <>
        <div>
            <Grid container spacing={4}
                  style={{
                      maxWidth: 500,
                      marginTop: 5
                  }}>
                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DateTimePicker
                            ampm={false}
                            label={t("general:from")}
                            value={pageStore.from.toDate()}
                            onChange={(value: Date) => {
                                pageStore.setTimeInterval(
                                    moment(value.getTime()),
                                    pageStore.to
                                );
                                pageStore.setPeriodName(Period.custom_period);
                                generalStore.showSnackbar({
                                    type: SnackbarType.success,
                                    title: t("general:labelOfUpdating")
                                })
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid item md={6} xs={6} lg={6}>
                    <FormControl>
                        <DateTimePicker
                            ampm={false}
                            label={t("general:to")}
                            value={pageStore.to.toDate()}
                            onChange={(value: Date) => {
                                pageStore.setTimeInterval(
                                    pageStore.from,
                                    moment(value.getTime()),
                                );
                                pageStore.setPeriodName(Period.custom_period);
                                generalStore.showSnackbar({
                                    type: SnackbarType.success,
                                    title: t("general:labelOfUpdating")
                                })
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    </>
};


export default observer(CustomTab)
